(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-sa-rotor]').forEach(function (rotor) {
    var words = rotor.querySelectorAll('.sa-rotor__w');
    if (words.length < 2) return;
    var widest = 0;
    words.forEach(function (w) { widest = Math.max(widest, w.offsetWidth); });
    if (widest) rotor.style.minWidth = widest + 'px';
    if (reduce) return;
    var i = 0;
    setInterval(function () {
      var cur = words[i];
      i = (i + 1) % words.length;
      cur.classList.remove('is-active');
      cur.classList.add('is-out');
      words[i].classList.remove('is-out');
      words[i].classList.add('is-active');
      setTimeout(function () { cur.classList.remove('is-out'); }, 700);
    }, 2400);
  });

  if (reduce) return;
  var bar = document.createElement('div');
  bar.className = 'sa-progress';
  document.body.appendChild(bar);
  var ticking = false;
  function update() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, window.scrollY / h) : 0) + ')';
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();
